import { AppUser } from "../../models/user/user";
import userStickerService from "../UserStickerService/UserStickerService";
import userApi from "../apis/UserApi/UserApi";
import localStorageService from "../localStorage/localStorage";

class UserService {
  async dangerouslyPermanentlyDeleteMe(userId: string): Promise<boolean> {
    const deleted = await userApi.dangerouslyPermanentlyDeleteMe(userId);

    if (deleted) this.signOut();

    return deleted;
  }
  /**
   * Adds an observer for changes to the user's state.
   *
   * @example
   * ```javascript
   * userService.registerAuthObserver((appUser: AppUser | null) => {
   *   if (appUser) {
   *     // User is signed in.
   *
   *   }
   * });
   * ```
   */
  registerUserObserver(callbackfn: (user: AppUser | null) => void) {
    userApi.registerUserObserver(callbackfn);
  }

  /**
   * Unsubcribes form changes to the user's state.
   */
  unregisterUserObserver() {
    userApi.unregisterUserObserver();
  }

  async updateUserInfo(appUser: AppUser) {
    await userApi.updateUser(appUser.id, appUser.toUpdatableAppUserJSON());
    await userStickerService.updateUserMissingAndRepeated(appUser.id);
  }

  signOut() {
    userApi.signOut();
    localStorageService.clear();
  }
}

export default new UserService();
